import { RootState } from '../store';

export const selectCouponName = (state: RootState) => state?.coupon?.nameCoupon;
export const selectCouponData = (state: RootState) => state?.coupon;
